import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import _ from 'lodash';
import { InvoiceGrid, ServiceThreadSpinner } from '.';
import { api, constants, dateHelpers, helpers } from '../utils';

export default function InvoiceSummary(props) {
   const navigate = useNavigate();
   const [customerId, setCustomerId] = useState(props.customerId);
   const [data, setData] = useState();
   const [loaded, setLoaded] = useState(false);
   const [page, setPage] = useState(1);
   const [showAll, setShowAll] = useState(false);
   const [sortDirection, setSortDirection] = useState("desc");
   const [sortField, setSortField] = useState("documentDate");
   const [totalPages, setTotalPages] = useState();
   const [totals, setTotals] = useState();

   useEffect(() => {
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId);
         setLoaded(false);
      }

      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId, showAll]);

   function createPayload() {
      let startDate = new Date();
      startDate = new Date(startDate.setDate(startDate.getDate() - 120));
      return {
         CustomerId: customerId,
         StartDate: dateHelpers.formatDateForServer(startDate),
         EndDate: dateHelpers.formatDateForServer(new Date()),
         ParentCustomer: false,
         OrderType: 0,
         PageNumber: page,
         PageSize: 10,
         SortField: sortField,
         SortDirection: sortDirection,
         showAll: showAll
      }
   }

   function exportXlsx() {
      const payload = createPayload()

      api
         .postGetBlob("Customer/ExportCustomerInvoicesXLSX", payload)
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r.data.message)) {
                  toast.error(r.data.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = `${payload.CustomerId}_Invoice_History.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post(`Customer/GetPaginatedCustomerInvoices`, createPayload())
         .then(response => {
            if (response.data.success) {
               setData(response.data.invoices.items);
               setTotalPages(_.ceil(response.data.invoices.totalCount / 10));
               setTotals(response.data.totals);
            }
            setLoaded(true);
         })
         .catch(api.catchHandler)
   }

   function onPageChange(page) {
      setPage(page);
      setLoaded(false);
   }

   function onShowAll(checked) {
      setLoaded(false);
      setShowAll(checked);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc")
      } else {
         setSortDirection(direction);
      }
      onPageChange(1);
   }

   return (
      <>
         <div>
            <span className="h2 me-2">Invoices Last 120 Days</span> <span className="text-muted">Customer #{customerId}</span>
            <Button
               className="shredButton float-end"
               children="More Invoices"
               onClick={() => navigate(`/invoices`)}
            />
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {data && data.length
               ? (<InvoiceGrid
                  data={data}
                  totals={totals}
                  sortCallback={onSortChange}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  pagerCallback={onPageChange}
                  pageNumber={page}
                  totalPages={totalPages}
                  exportXlsxCallback={exportXlsx}
                  onShowAll={onShowAll}
                  showAll={showAll}
               />)
               : (<span className="h5">No Invoice Activity for the last 120 days found</span>)
            }
         </ServiceThreadSpinner>
      </>
   )
}